import { jsx } from 'react/jsx-runtime';
import isNil from 'lodash/isNil';
import { createContext, useState, useEffect, useContext } from 'react';
import { useHTMLElementObserver } from './useHTMLElementObserver.js';

const CollapsibleContext = createContext({
    open: false,
    toggle: () => undefined,
});
const CollapsibleButton = ({ children }) => {
    const { toggle } = useCollapsible();
    return (jsx("div", { className: "cursor-pointer", onClick: () => toggle(), children: children }));
};
const CollapsiblePanel = ({ children, minHeight }) => {
    const [contentMaxHeight, setContentMaxHeight] = useState(0);
    const { contentRef } = useHTMLElementObserver({
        onChange: (elem) => {
            setContentMaxHeight(elem.getBoundingClientRect().height);
        },
    });
    const [isMount, setIsMount] = useState(false);
    const { open } = useCollapsible();
    useEffect(() => {
        setTimeout(() => {
            setIsMount(true);
        }, 100);
    }, []);
    return (jsx("div", { className: `max-h-0 overflow-hidden ${isMount ? 'transition-max-height duration-300' : ''} -mx-1 px-1`, style: {
            minHeight: `${minHeight}px`,
            maxHeight: `${open ? contentMaxHeight : 0}px`,
        }, children: jsx("div", { className: "text-paragraph font-normal", ref: contentRef, children: children }) }));
};
const Collapsible = ({ children, open, onToggle }) => {
    const [unControlledOpen, setUnControlledOpen] = useState(false);
    const isUncontrolled = isNil(open);
    const isOpen = isUncontrolled ? unControlledOpen : open;
    const setIsOpen = isUncontrolled
        ? (val) => {
            setUnControlledOpen(val);
            onToggle === null || onToggle === void 0 ? void 0 : onToggle(val);
        }
        : onToggle;
    const toggle = (value) => {
        if (typeof value === 'boolean') {
            setIsOpen === null || setIsOpen === void 0 ? void 0 : setIsOpen(value);
        }
        else {
            setIsOpen === null || setIsOpen === void 0 ? void 0 : setIsOpen(!isOpen);
        }
    };
    return (jsx("div", { children: jsx(CollapsibleContext.Provider, { value: {
                open: isOpen,
                toggle,
            }, children: typeof children === 'function' ? children({ open: isOpen, toggle }) : children }) }));
};
const useCollapsible = () => {
    return useContext(CollapsibleContext);
};

export { Collapsible, CollapsibleButton, CollapsiblePanel, useCollapsible };
